import { routeFns } from "../../../app/router/routes";
import { systemRights } from "@tedivo/tvd-api-models";

export const TOGGLE_CHILDREN = "toggle-children" as const;

const MenuDefinition: IMenuItem[] = [
  {
    label: "menu:home",
    systemRights: [systemRights.NOT_LOGGED_IN],
    action: routeFns.login(),
    icon: "house",
  },
  {
    label: "menu:cloud",
    systemRights: [systemRights.ORG.ListOwnOrgFiles],
    action: routeFns.myCloud(),
    icon: "folder",
  },
  {
    label: "menu:community",
    systemRights: [systemRights.ORG.ListPublicFiles],
    action: routeFns.communityFiles(),
    iconSrc: "/assets/images/tedivo-library-icon-color.svg",
    iconSrcDark: "/assets/images/tedivo-library-icon-knockout.svg",
  },
  {
    label: "menu:files",
    action: TOGGLE_CHILDREN,
    icon: "file-earmark-plus",
    actionBase: "/" + routeFns.ovdNew().split("/")[1],
    isHiddenInReadOnly: true,
    menuItems: [
      {
        label: "menu:newOVD",
        action: routeFns.ovdNew(),
        icon: "file-plus",
        systemRights: [systemRights.USER.CreateFile],
      },
      {
        label: "menu:fileOpen",
        action: routeFns.ovdOpen(),
        icon: "file-code",
        systemRights: [systemRights.USER.CreateFile],
      },
      {
        label: "menu:fileImportStaf",
        action: routeFns.importStaf(),
        icon: "file-arrow-up",
        systemRights: [systemRights.USER.CreateFile],
      },
    ],
  },
  {
    label: "menu:organization",
    action: routeFns.myOrganization(),
    icon: "building-fill-gear",
    systemRights: [systemRights.USER.CreateUser],
  },
  {
    label: "menu:apiKeys",
    action: routeFns.apiKeys(),
    icon: "key",
    systemRights: [systemRights.USER.UserCanViewApiKeys],
  },
  {
    label: "menu:tedivoAdmin",
    action: TOGGLE_CHILDREN,
    icon: "eyeglasses",
    actionBase: "/" + routeFns.adminOrganizations().split("/")[1],
    isHiddenInReadOnly: true,
    menuItems: [
      {
        label: "general:organizations.organizations",
        action: routeFns.adminOrganizations(),
        icon: "building-fill-gear",
        systemRights: [systemRights.ORG.AppAdminCrudOrganization],
      },
      {
        label: "general:parentOrganizations.title",
        action: routeFns.adminParentOrganizations(),
        icon: "houses",
        systemRights: [systemRights.ORG.AppAdminCrudOrganization],
      },
      {
        label: "general:users.users",
        action: routeFns.adminUsers(),
        icon: "people",
        systemRights: [systemRights.ORG.AppAdminCrudOrganization],
      },
      {
        label: "general:organizations.federations.title",
        action: routeFns.adminDomainFederations(),
        icon: "ticket-perforated",
        systemRights: [systemRights.ORG.AppAdminCrudOrganization],
      },
      {
        label: "general:domains.title",
        action: routeFns.adminDomains(),
        icon: "envelope-x",
        systemRights: [systemRights.ORG.AppAdminDomains],
      },
      {
        label: "textures:title",
        action: routeFns.adminTextures(),
        icon: "box",
        systemRights: [systemRights.ORG.AppAdminCrudOrganization],
      },
    ],
  },
];

export type IMenuItem = {
  label: string;
  menuItems?: IMenuItem[];
  isHiddenInReadOnly?: boolean;
} & (
  | {
      action: typeof TOGGLE_CHILDREN;
      systemRights?: never;
      actionBase: string;
    }
  | {
      action: string;
      actionBase?: never;
      systemRights: string[];
    }
) &
  (
    | {
        icon: string;
        iconSrc?: never;
        iconSrcDark?: never;
      }
    | {
        icon?: never;
        iconSrc: string;
        iconSrcDark?: string;
      }
  );

export default MenuDefinition;
